import { mapOptionsToSearchListingsParams } from '@pkgs/api/utils/mapParams';
import { mapSearchListingsFiltersToSearchFilterRequest } from '@pkgs/api/utils/filters';
import { getErrorResult } from '@pkgs/api/utils/error';
import { type ApiConfig, type ApiResult, type SearchListingsFilters, type SearchListingsOptions } from '@pkgs/api/types';
import { searchListings as generatedSearchListings, type SearchFilterRequest, type SearchListingsResponse } from '@generated/search-bff';

import { getConfigWithMetadata } from '../../utils/headers';

/**
 * Fetch property listings based on provided filters and options using the `/api/v2/listing/search` endpoint.
 *
 * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/listings/searchListings Search API Documentation}
 */
export async function searchListings(
  filters: SearchListingsFilters,
  options: SearchListingsOptions,
  apiConfig: ApiConfig,
): Promise<ApiResult<SearchListingsResponse, unknown, { appliedFilters: SearchFilterRequest }>> {
  const _apiConfig = getConfigWithMetadata(apiConfig, 'searchListings');

  const params = mapOptionsToSearchListingsParams(options);
  const appliedFilters = mapSearchListingsFiltersToSearchFilterRequest(filters, options);

  try {
    const data = await generatedSearchListings(appliedFilters, params, _apiConfig);

    return {
      status: 'success',
      data,
      metadata: { appliedFilters },
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error, { appliedFilters });
  }
}
